export default __webpack_public_path__ + "static/media/0xe0b52e49357fd4daf2c15e02058dce6bc0057db4.b9e46dc2.webp";